import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { IndustriesPage } from './pages/IndustriesPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { TeamPage } from './pages/TeamPage';
import { ContactPage } from './pages/ContactPage';
type PageType = 'home' | 'about' | 'services' | 'industries' | 'projects' | 'team' | 'contact';
const pageVariants = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: {
    opacity: 1,
    y: 0
  },
  exit: {
    opacity: 0,
    y: -20
  }
};
export function App() {
  const [currentPage, setCurrentPage] = useState<PageType>('home');
  const handleNavigate = (page: PageType | string) => {
    setCurrentPage(page as PageType);
  };
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage onNavigate={handleNavigate} data-id="element-0" />;
      case 'about':
        return <AboutPage data-id="element-1" />;
      case 'services':
        return <ServicesPage data-id="element-2" />;
      case 'industries':
        return <IndustriesPage data-id="element-3" />;
      case 'projects':
        return <ProjectsPage data-id="element-4" />;
      case 'team':
        return <TeamPage data-id="element-5" />;
      case 'contact':
        return <ContactPage data-id="element-6" />;
      default:
        return <Hero onNavigate={handleNavigate} data-id="element-7" />;
    }
  };
  return <div className="min-h-screen bg-gesl-offWhite" data-id="element-8">
      <Navbar currentPage={currentPage} onNavigate={handleNavigate} data-id="element-9" />
      <main data-id="element-10">
        <AnimatePresence mode="wait" data-id="element-11">
          <motion.div key={currentPage} variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={{
          duration: 0.3
        }} data-id="element-12">
            {renderPage()}
          </motion.div>
        </AnimatePresence>
      </main>
      <Footer onNavigate={handleNavigate} data-id="element-13" />
    </div>;
}